module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/4/3-5abd9b15360d795a79f3c953b5add39b.jpg";